<template>
          <div class="left col-lg-4">
          <div class="photo-left image-container">
          <el-image class="photo"
            :src="selectedLocation.logo"
          >
            <div slot="placeholder" class="image-slot">
              <i class="fa fa-circle-o-notch fa-spin fa-1x fa-fw"></i>
            </div>
            <div slot="error" class="image-slot text">
              <img src="img/logo-error-200.png" />
            </div>
          </el-image>
          </div>

          <h4 class="name">{{ selectedLocation.name }}</h4>
          <p class="info">{{ selectedLocation.email }}</p>
          <div class="stats row">
            <div class="stat col-xs-4">
              <p class="number-stat">{{reviews ? reviews.length : 0}}</p>
              <p class="desc-stat">{{ $t("text.reviews") }}</p>
            </div>
          </div>
          <p v-if="locationStatus && locationStatus.open" class="desc open-status">
            <span class="open">{{ $t("text.open_now") }}</span>
          </p>
          <p v-else class="desc open-status"><span class="closed">{{ $t("text.closed_for_now") }}</span></p>
          <p
            class="desc"
            v-html="
              `<strong>${$t('text.address')} : </strong>` +
                getHelpers.generateFromatedAddress(selectedLocation.address)
            "
          ></p>
        </div>
</template>

<script>
import {mapState} from 'vuex'
import { helpers } from "@/utilities";
export default {
  name:'left-location-details',
  props:{
    locationStatus : Object
  },
  computed:{
    ...mapState ( {
      reviews : state=>state.locationReviews
    })
  },
  data(){
    return {
      getHelpers : helpers,
    }
  }
}
</script>